import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { Observable, Observer, of } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';

@Injectable()
export class AdminAccountGuard {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly authGuardService: MsalGuard
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Observable<boolean>((observer: Observer<boolean>) => {
      this.authGuardService.canActivate(route, state).subscribe((auth: boolean) => {
        if(!auth)
          return of(false);

        const account = this.authService.getCurrentAccount();

        if (account && account.id === 85) {
          observer.next(true);
        } else {
          void this.router.navigateByUrl(`${account.accountUID}/settings`);
        }
      })
    });
  }
}
